(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pizza = function () {
  function Pizza(_ref) {
    var _ref$name = _ref.name;
    var name = _ref$name === undefined ? '' : _ref$name;
    var _ref$dough = _ref.dough;
    var dough = _ref$dough === undefined ? '' : _ref$dough;
    var _ref$sauce = _ref.sauce;
    var sauce = _ref$sauce === undefined ? '' : _ref$sauce;
    var _ref$toppings = _ref.toppings;
    var toppings = _ref$toppings === undefined ? [] : _ref$toppings;

    _classCallCheck(this, Pizza);

    this.name = name;
    this.dough = dough;
    this.sauce = sauce;
    this.toppings = toppings;
  }

  _createClass(Pizza, [{
    key: 'prepare',
    value: function prepare() {
      console.log("Preparing " + this.name);
      console.log("Tossing dough...");
      console.log("Adding sauce");
      console.log("Adding toppings:");

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.toppings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var topping = _step.value;

          console.log(topping + "  ");
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'bake',
    value: function bake() {
      console.log("Bake for 25 minutes at 350");
    }
  }, {
    key: 'cut',
    value: function cut() {
      console.log("Cutting the pizza into diagonal slices");
    }
  }, {
    key: 'box',
    value: function box() {
      console.log("Place pizza in official PizzaStore box");
    }
  }, {
    key: 'getName',
    value: function getName() {
      return this.name;
    }
  }]);

  return Pizza;
}();

exports.default = Pizza;

},{}],2:[function(require,module,exports){
"use strict";

var _NewYorkPizzaStore = require("./stores/NewYorkPizzaStore");

var _NewYorkPizzaStore2 = _interopRequireDefault(_NewYorkPizzaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oPizzaStore = new _NewYorkPizzaStore2.default();
oPizzaStore.orderPizza("cheese");

},{"./stores/NewYorkPizzaStore":7}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pizza2 = require('../../Pizza');

var _Pizza3 = _interopRequireDefault(_Pizza2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheesePizza = function (_Pizza) {
  _inherits(CheesePizza, _Pizza);

  function CheesePizza() {
    _classCallCheck(this, CheesePizza);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(CheesePizza).call(this, {
      name: 'NY Style Sauce and Cheese Pizza',
      dough: 'Thin Crust Dough',
      sauce: 'Marinara sauce',
      toppings: ["Grated Reggiano Cheese"]
    }));
  }

  return CheesePizza;
}(_Pizza3.default);

exports.default = CheesePizza;

},{"../../Pizza":1}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pizza2 = require('../../Pizza');

var _Pizza3 = _interopRequireDefault(_Pizza2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClamPizza = function (_Pizza) {
  _inherits(ClamPizza, _Pizza);

  function ClamPizza() {
    _classCallCheck(this, ClamPizza);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ClamPizza).call(this, {
      name: 'NY Style Sauce and Clam Pizza',
      dough: 'Thin Crust Dough',
      sauce: 'Marinara sauce',
      toppings: ["Grated Reggiano Cheese", 'Clams']
    }));
  }

  return ClamPizza;
}(_Pizza3.default);

exports.default = ClamPizza;

},{"../../Pizza":1}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pizza2 = require('../../Pizza');

var _Pizza3 = _interopRequireDefault(_Pizza2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PepperoniPizza = function (_Pizza) {
  _inherits(PepperoniPizza, _Pizza);

  function PepperoniPizza() {
    _classCallCheck(this, PepperoniPizza);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(PepperoniPizza).call(this, {
      name: 'NY Style Sauce and Pepperoni Pizza',
      dough: 'Thin Crust Dough',
      sauce: 'Marinara sauce',
      toppings: ["Grated Reggiano Cheese", 'Pepperoni']
    }));
  }

  return PepperoniPizza;
}(_Pizza3.default);

exports.default = PepperoniPizza;

},{"../../Pizza":1}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pizza2 = require('../../Pizza');

var _Pizza3 = _interopRequireDefault(_Pizza2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VeggiePizza = function (_Pizza) {
  _inherits(VeggiePizza, _Pizza);

  function VeggiePizza() {
    _classCallCheck(this, VeggiePizza);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(VeggiePizza).call(this, {
      name: 'NY Style Sauce and Veggie Pizza',
      dough: 'Thin Crust Dough',
      sauce: 'Marinara sauce',
      toppings: ["Grated Reggiano Cheese", 'Paprika', 'Tomato', 'Beans']
    }));
  }

  return VeggiePizza;
}(_Pizza3.default);

exports.default = VeggiePizza;

},{"../../Pizza":1}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PizzaStore2 = require('../../../common/PizzaStore');

var _PizzaStore3 = _interopRequireDefault(_PizzaStore2);

var _CheesePizza = require('../pizzas/NewYorkStyle/CheesePizza');

var _CheesePizza2 = _interopRequireDefault(_CheesePizza);

var _VeggiePizza = require('../pizzas/NewYorkStyle/VeggiePizza');

var _VeggiePizza2 = _interopRequireDefault(_VeggiePizza);

var _ClamPizza = require('../pizzas/NewYorkStyle/ClamPizza');

var _ClamPizza2 = _interopRequireDefault(_ClamPizza);

var _PepperoniPizza = require('../pizzas/NewYorkStyle/PepperoniPizza');

var _PepperoniPizza2 = _interopRequireDefault(_PepperoniPizza);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PIZZAS = {
  cheese: _CheesePizza2.default,
  veggie: _VeggiePizza2.default,
  clam: _ClamPizza2.default,
  pepperoni: _PepperoniPizza2.default
};

var NewYorkPizzaStore = function (_PizzaStore) {
  _inherits(NewYorkPizzaStore, _PizzaStore);

  function NewYorkPizzaStore() {
    _classCallCheck(this, NewYorkPizzaStore);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewYorkPizzaStore).apply(this, arguments));
  }

  _createClass(NewYorkPizzaStore, [{
    key: 'createPizza',
    value: function createPizza(type) {
      var PizzaConstructor = PIZZAS[type];
      var pizza = null;
      if (PizzaConstructor) {
        pizza = new PizzaConstructor();
      }
      return pizza;
    }
  }]);

  return NewYorkPizzaStore;
}(_PizzaStore3.default);

exports.default = NewYorkPizzaStore;

},{"../../../common/PizzaStore":8,"../pizzas/NewYorkStyle/CheesePizza":3,"../pizzas/NewYorkStyle/ClamPizza":4,"../pizzas/NewYorkStyle/PepperoniPizza":5,"../pizzas/NewYorkStyle/VeggiePizza":6}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PizzaStore = function () {
  function PizzaStore() {
    _classCallCheck(this, PizzaStore);
  }

  _createClass(PizzaStore, [{
    key: "createPizza",
    value: function createPizza() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "orderPizza",
    value: function orderPizza(type) {
      var pizza = this.createPizza(type);

      pizza.prepare();
      pizza.bake();
      pizza.cut();
      pizza.box();
    }
  }]);

  return PizzaStore;
}();

exports.default = PizzaStore;

},{}]},{},[2])

